import React, { useCallback, useMemo } from 'react';

import { Checkbox } from '@appcharge/shared-ui';

import { schemaUtils } from '../../../integration-test-modal.utils';
import { IBooleanFieldProps } from '../schema-form-field.types';

export const BooleanField: React.FC<IBooleanFieldProps> = ({
  name,
  path,
  property,
  value,
  onChange,
  required
}) => {
  const fieldLabel = useMemo(
    () => schemaUtils.formatFieldLabel(name, property.title),
    [property.title, name]
  );

  const handleBooleanChange = useCallback(
    (checked: boolean) => {
      onChange(path, checked);
    },
    [path, onChange]
  );

  return (
      <Checkbox
        required={required}
        isDisabled={property.readOnly}
        disabled={property.readOnly}
        label={fieldLabel}
        description={property.description}
        checked={Boolean(value)}
        onCheckedChange={handleBooleanChange}
      />
  );
};
